"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var _get = require('lodash/get');
/**
 * Input field for a textual filter value.
 */
var TextFilterField = /** @class */ (function (_super) {
    __extends(TextFilterField, _super);
    function TextFilterField(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Extracts the text value of the event object of 'onChange'
         * and passes it to the passed in 'onValueChange' handler.
         */
        _this.onInputChange = function (e) {
            var onValueChange = _this.props.onValueChange;
            if (onValueChange) {
                onValueChange(e.target.value);
            }
            _this.setState({ value: e.target.value });
        };
        _this.onAutoCompleteChange = function (value) {
            var onValueChange = _this.props.onValueChange;
            if (onValueChange) {
                onValueChange(value);
            }
            _this.setState({ value: value });
        };
        _this.getSampleValuesFromFeatures = function () {
            var _a = _this.props, selectedAttribute = _a.selectedAttribute, internalDataDef = _a.internalDataDef;
            var sampleValues = [];
            var features = _get(internalDataDef, 'exampleFeatures.features') || [];
            features.forEach(function (feature) {
                var value = _get(feature, "properties[" + selectedAttribute + "]");
                if (value && sampleValues.indexOf(value) === -1) {
                    sampleValues.push(value);
                }
            });
            return sampleValues.sort();
        };
        _this.state = {
            value: _this.props.value
        };
        return _this;
    }
    TextFilterField.getDerivedStateFromProps = function (nextProps, prevState) {
        return {
            value: nextProps.value
        };
    };
    TextFilterField.prototype.render = function () {
        var helpTxt = this.props.validateStatus !== 'success' ? this.props.help : null;
        var sampleValues = this.getSampleValuesFromFeatures();
        return (React.createElement("div", { className: "gs-text-filter-fld" },
            React.createElement(antd_1.Form.Item, { label: this.props.label, colon: false, validateStatus: this.props.validateStatus, help: helpTxt, hasFeedback: true }, sampleValues.length > 0 ?
                React.createElement(antd_1.AutoComplete, { value: this.state.value, style: { width: '100%' }, onChange: this.onAutoCompleteChange, placeholder: this.props.placeholder, dataSource: sampleValues, filterOption: function (value, option) {
                        return option.key.toLowerCase().includes(value.toLowerCase());
                    } })
                :
                    React.createElement(antd_1.Input, { draggable: true, onDragStart: function (e) { return e.preventDefault(); }, value: this.state.value, style: { width: '100%' }, onChange: this.onInputChange, placeholder: this.props.placeholder }))));
    };
    TextFilterField.defaultProps = {
        label: 'Value',
        placeholder: 'Enter Text Value',
        value: undefined,
        validateStatus: 'success',
        help: 'Please enter a text.'
    };
    return TextFilterField;
}(React.Component));
exports.TextFilterField = TextFilterField;
exports.default = TextFilterField;
//# sourceMappingURL=TextFilterField.js.map